import { ReportsModule } from "@/modules/reports-objective";
import { Vue, Component, Ref } from "vue-property-decorator";
import Grid from "@/components/wijmo-grid/grid/grid.vue";
import { VersionGroupModule } from "@/modules/versiongroup";
import { disabledDueToAccessLevel, getRouteAccessLevel, pureRichText } from "@/util/func";
import { IWorkbookCell } from "wijmo/wijmo.xlsx";
import { fmtMsg } from "commonui";
import { ReportsLocale } from "@/locales/localeid";
import { LevelBinding } from "@/util/constants";
import { AccessLevel, MediaPlayerContentType, MediaSlot, MediaType } from "@/util/enum";
import IPdfPagesViewer from "@/components/pdf-pages-viewer/pdf-pages-viewer";
import PdfPagesViewer from "@/components/pdf-pages-viewer/pdf-pages-viewer.vue";
import VideoJSPlayer from "@/components/videojsplayer/videojsplayer.vue";
import IVideoJSPlayer from "@/components/videojsplayer/videojsplayer";
import { ResourceService } from "@/services/resource";
import { isString } from "lodash";

export interface GridData {
	unit: {
		displayName: string;
		sequence: number;
	};
	component: string;
	levelNumber: string;
	level1: string;
	level2: string;
	level3: string;
	level4: string;
}

export enum UnitDataMapper {
	DisplayNameProp = 1,
	UnitProp = 2
}
@Component({
	components: { Grid, VideoJSPlayer, PdfPagesViewer }
})
export default class FocusWordsByChapter extends Vue {
	accessLevel = AccessLevel;
	@Ref("pdfPagesViewerRef") pdfPagesViewerRef!: IPdfPagesViewer;
	@Ref("videoPlayerRef") videoPlayerRef!: IVideoJSPlayer;

	gridData() {
		return ReportsModule.focusWordChapterReportData;
	}
	get isGridLoading() {
		return ReportsModule.componentObjectiveGridLoading;
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	get exportOptions() {
		return {
			filename: fmtMsg(ReportsLocale.ReportsFocusWordChapterExportedFileName),
			formatCell: (cell: IWorkbookCell, binding: string) => {
				if (binding == "wordAudio" || binding == "definitionAudio" || binding == "image") {
					if (cell.value) {
						cell.value = this.formatMessage(this.reportsLocale.ReportsFocusWordsByChapterYes);
					} else {
						cell.value = this.formatMessage(this.reportsLocale.ReportsFocusWordsByChapterNo);
					}
				}
			}
		};
	}

	get reportsLocale() {
		return ReportsLocale;
	}

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}

	public async viewMedia(mediaId, mediaSlotId, mediaTypeId, fileUrl) {
		if (mediaSlotId === MediaSlot.Audio || mediaSlotId === MediaSlot.IndividualAudio) {
			if (isString(fileUrl) && mediaId) {
				const fileUrl = await ResourceService.getDownloadMediaUrl(mediaId);
				const result = this.videoPlayerRef.showModal(mediaId as string, MediaType.MP3, "Media Viewer");
				if (result) {
					setTimeout(() => {
						this.videoPlayerRef.setAWSMediaPlayer(mediaId as string, fileUrl, MediaPlayerContentType.mp3);
					}, 100);
				}
			}
		} else {
			if (isString(fileUrl) && mediaId) {
				this.pdfPagesViewerRef.open({
					mediaId: mediaId,
					mediaSlotId: MediaSlot.Image
				});
			}
		}
	}

	beforeDestroy() {
		ReportsModule.setFocusWordChapterReportData([]);
	}
}
